import _ from 'underscore';
import Backbone from 'backbone';
import { state } from '../state-manager/state-model';
import { domainReplacer, toTextTags, toCommaTags, toShort, addComma } from '../utils';
import { LINKS } from '../config';

export var UserInfoModel = Backbone.Model.extend({
  url: 'user-info',

  parse: function (res) {
    var ssn = state.get('ssn');
    var gameName = state.get('gameName');
    var membership = state.get('membership');

    var result = res.result;
    var totalMoney = result.money + result.moneyInSafe;

    // 보유 머니
    var totalMoneyTags = toTextTags(toShort(totalMoney));

    // 보유 구슬
    var marbleCountTags = toCommaTags(Math.min(result.marbleCount, result.marbleCountMax));

    // NOTE: 보유 구슬 한도 초과. 신규 가입자는 marbleCountMax 가 null 인지 먼저 체크해야 한다.
    var isMarbleCountMax = result.marbleCountMax && result.marbleCount >= result.marbleCountMax;

    // 머니보기 버튼이 새줄로 떨어져야 하는 지?
    var isPbalanceCheckNewLine = String(totalMoney).length > 10 && result.hasExcessMoney;

    // 보유 피망 캐쉬
    var pmangCashText = addComma(result.pmangCash);

    // 상세 : 소지 머니
    var moneyTags = toTextTags(result.money);

    // 상세 : 금고 머니
    var moneyInSafeTags = toTextTags(result.moneyInSafe);

    // 채널링일 경우 도메인을 바꿔주는 함수
    var replaceURL = domainReplacer.create();

    // 초과 머니 보유했을 경우 팝업 링크 : NL 팝업, 게임과 멤버십 등급에 따라 구분해서 노출
    var excessLink = replaceURL(LINKS.extMoneyPopup + '?ssn=' + ssn + '&class_grade=' + membership);

    // 피망 캐쉬 충전 팝업
    var rechargeLink = result.rechargeLink;

    // result 중에서 뷰에 바로 나가는 필드
    // maxMoney : 보유 머니 한도

    return _.extend(result, {
      gameName: gameName,

      moneyTags: moneyTags,
      moneyInSafeTags: moneyInSafeTags,

      isPbalanceCheckNewLine: isPbalanceCheckNewLine,

      totalMoney: totalMoney,
      totalMoneyTags: totalMoneyTags,

      marbleCountTags: marbleCountTags,
      isMarbleCountMax: isMarbleCountMax,

      pmangCashText: pmangCashText,

      excessLink: excessLink,
      rechargeLink: rechargeLink
    });
  }
});
